<template>
  <b-modal
    id="waiveEfeeLogs"
    v-model="show"
    centered
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-header>
      <h5 class="modal-title">Waive EFee Logs</h5>
      <button type="button" class="close" @click="$emit('onCloseModal') && (logData = [])">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div class="employerTable-card p-0 mt-0 mb-3 table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th v-if="type=='group'">Rep Id</th>
            <th v-if="type == 'group'">Group Id</th>
            <!-- <th>Waived Amount</th> -->
            <th>Reason</th>
            <th>User</th>
            <th>Action From</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody v-if="logData.length == 0">
          <tr class="text-center">
            <td colspan="8" class="text-center">No Records Found</td>
          </tr>
        </tbody>
        <tbody v-for="logs in logData" :key="logs.id">
          <tr>
            <td v-if="type=='group'">{{ logs.elgb_agent }}</td>
            <td v-if="type == 'group'">{{ logs.group_id }}</td>
            <!-- <td>$125</td> -->
            <td>
              {{ logs.elgb_comment }}
            </td>
            <td>{{ logs.elgb_agentname}}</td>
            <td>{{ logs.act_from||"NA" }}</td>
            <td>{{ logs.elgb_act_date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-end align-items-center gap-2">
      <!-- <button class="btn univ-btn sendBtn mb-0 mt-0 btn-secondary">
        Yes
      </button> -->
      <!-- <button
        class="btn cancel-btn btn-secondary h-100"
        @click="$emit('onCloseModal')"
      >
        Close
      </button> -->
    </div>
  </b-modal>
</template>

<script>
import Api from "@/resource/Api";
export default {
  name: "WaiveEfeeLogs",
  props: {
    show: { type: Boolean, default: false },
    type: { type: String},
    row: { type: Object, default: () => {} },
  },
  data() {
    return {
      data: null,
      internalShow: this.show,
      logData: [],
    };
  },
  watch: {
    show(newVal) {
      if (newVal && this.row.group_id) {
        this.getWaiveEfeeLogs();
      }
    },
  },
  methods: {
    async getWaiveEfeeLogs() {
      let loader = this.$loading.show();
      const url = "v2/group-efee-logs?gid=" + this.row.group_id;
      try {
        const res = await Api.get(url);
        this.logData = res?.data?.data || [];
      } catch (err) {
        this.$notify(
          err?.response?.data?.message || "something went wrong",
          "error"
        );
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style>
#waiveEfeeLogs .modal-header {
  display: flex !important;
}
</style>
<style scoped>
.waive-field {
  width: 100%;
  border: 1px solid #dce1e7;
  outline: none;
  border-radius: 6px;
  padding: 9px 15px;
  font-size: 14px;
  transition: all ease 0.6s;
}
#waiveEfeeLogs .modal-footer {
  display: none;
}
#waiveEfeeLogs .univ-btn {
  max-width: 100%;
}
th {
  border-bottom: 0 !important;
  background: #fafbfd;
}
</style>
